"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _Hotel = _interopRequireDefault(require("../../icons-react/rebrand/Hotel"));
var EmptyGallery = function EmptyGallery() {
  return /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(Icon, null), /*#__PURE__*/_react["default"].createElement(Text, null, _localization.i18n.t('hotel.room.noFoto')));
};
var Icon = (0, _styledComponents["default"])(_Hotel["default"]).withConfig({
  displayName: "EmptyGallery__Icon",
  componentId: "sc-1ob6wdc-0"
})(["height:24px;path{fill:var(--white);}"]);
var Container = _styledComponents["default"].div.withConfig({
  displayName: "EmptyGallery__Container",
  componentId: "sc-1ob6wdc-1"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;gap:4px;background-color:var(--grey3);border-radius:var(--border-radius);height:170px;"]);
var Text = _styledComponents["default"].span.withConfig({
  displayName: "EmptyGallery__Text",
  componentId: "sc-1ob6wdc-2"
})(["color:var(--white);font-size:14px;font-weight:400;"]);
var _default = exports["default"] = EmptyGallery;